import React, { useState } from "react";
import ReactPlayer from "react-player";

import FALCOMM_LOGO from "assets/img/FALCOMM_LOGO.png";

function VideoPlayer({
	thumbnail,
	endThumbnail,
	url,
}) {
	
	const renderVideo = () => {
		return (
            <ReactPlayer
				url={url}
				playing={true}
				light={
					<img
						className='article-details-image'
						style={{ objectFit: thumbnail ? "cover" : "contain" }} 
						src={thumbnail ? thumbnail : FALCOMM_LOGO}
						alt='Thumbnail'
						onError={({ currentTarget }) => {
							currentTarget.onerror = null; // prevents looping
							currentTarget.src= FALCOMM_LOGO;
						}}
					/>
				}
				controls
				width='100%'
				height='450px'
				style={{ backgroundColor: "#000" }}
				config={{ file: { attributes: { controlsList: "nodownload", disablePictureInPicture: true }}}}
			/>
        );
	};

	return (
		<div>
			{renderVideo()}
		</div>
	);
}

export default React.memo(VideoPlayer);

